import { ChangePasswordForm } from '@/modules/Users/ChangePassword.form';
import { ResetType } from '@/modules/Users/Users.schema';

const ChangePassword = ({ reset_type }: { reset_type: ResetType.PASSWORD | ResetType.ONBOARDING }) => (
  <ChangePasswordForm reset_type={reset_type} />
);

export default ChangePassword;
